export const yodaIdentityConstants = {
  GET_ONE_REQUEST: "YODAIDENTITY_GET_ONE_REQUEST",
  GET_ONE_SUCCESS: "YODAIDENTITY_GET_ONE_SUCCESS",
  GET_ONE_FAILURE: "YODAIDENTITY_GET_ONE_FAILURE",

  GET_CUSTOMERS_REQUEST: "YODAIDENTITY_GET_CUSTOMERS_REQUEST",
  GET_CUSTOMERS_SUCCESS: "YODAIDENTITY_GET_CUSTOMERS_SUCCESS",
  GET_CUSTOMERS_FAILURE: "YODAIDENTITY_GET_CUSTOMERS_FAILURE",

  GET_DOORS_REQUEST: "YODAIDENTITY_GET_DOORS_REQUEST",
  GET_DOORS_SUCCESS: "YODAIDENTITY_GET_DOORS_SUCCESS",
  GET_DOORS_FAILURE: "YODAIDENTITY_GET_DOORS_FAILURE",

  GET_ADDRESSES_REQUEST: "YODAIDENTITY_GET_ADDRESSES_REQUEST",
  GET_ADDRESSES_SUCCESS: "YODAIDENTITY_GET_ADDRESSES_SUCCESS",
  GET_ADDRESSES_FAILURE: "YODAIDENTITY_GET_ADDRESSES_FAILURE",

  GET_LINES_REQUEST: "YODAIDENTITY_GET_LINES_REQUEST",
  GET_LINES_SUCCESS: "YODAIDENTITY_GET_LINES_SUCCESS",
  GET_LINES_FAILURE: "YODAIDENTITY_GET_LINES_FAILURE",

  GET_ORDER_CONFIGURATIONS_REQUEST:
    "YODAIDENTITY_GET_ORDER_CONFIGURATIONS_REQUEST",
  GET_ORDER_CONFIGURATIONS_SUCCESS:
    "YODAIDENTITY_GET_ORDER_CONFIGURATIONS_SUCCESS",
  GET_ORDER_CONFIGURATIONS_FAILURE:
    "YODAIDENTITY_GET_ORDER_CONFIGURATIONS_FAILURE",

  GET_COLORS_REQUEST: "YODAIDENTITY_GET_COLORS_REQUEST",
  GET_COLORS_SUCCESS: "YODAIDENTITY_GET_COLORS_SUCCESS",
  GET_COLORS_FAILURE: "YODAIDENTITY_GET_COLORS_FAILURE",
};
